import React from "react";
import type BaseModel from "../../models/BaseModel";

/** Renders a read-only title using the same presentation rules as navigator rows. */
export default function NavigatorObjectTitle({ object }: { object: BaseModel }) {
  const view = object.treeViewModel;
  const fullTitle = view.getFullTitle(true);
  const prefix = view.getTitlePrefix();
  const postfix = view.getTitlePostfix();
  const tag = !fullTitle && view.getTagNeeded() ? view.getTag() : "";
  const name = !fullTitle && view.getNameNeeded()
    ? object.displayName
    : "";

  return <>{prefix}{tag}{tag && (fullTitle || name) ? " " : ""}{fullTitle || name}{postfix}</>;
}
